import { render, staticRenderFns } from "./MyQrcode.vue?vue&type=template&id=5c4a75ac&scoped=true&"
import script from "./MyQrcode.vue?vue&type=script&lang=js&"
export * from "./MyQrcode.vue?vue&type=script&lang=js&"
import style0 from "./MyQrcode.vue?vue&type=style&index=0&id=5c4a75ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a75ac",
  null
  
)

export default component.exports